import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { noop } from 'rxjs';
import { ApiService } from '../../../api.service';
import { noWhitespaceInRequiredValidator, password_validation } from '../../../shared/constants';
declare var $: any;

@Component({
	selector: 'app-change-password-form',
	templateUrl: './change-password-form.component.html',
	styleUrl: './change-password-form.component.css'
})
export class ChangePasswordFormComponent implements OnChanges {
	passwordForm: FormGroup = this.formBuilder.group({
		password: [null, [Validators.required, noWhitespaceInRequiredValidator, password_validation]],
		confirmPassword: [null, [Validators.required, noWhitespaceInRequiredValidator]],
	}, {
		validators: this.passwordMatchValidator.bind(this)
	});
	customError: any = {};
	formSubmitted = false;
	hideP = true;
	showLoader = false;
	@Input() username: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	modalId = "resetPasswordModal" + this.getRandom5DigitNumber();
	getRandom5DigitNumber() {
		return Math.floor(Math.random() * 90000) + 10000;
	}

	constructor(private _snackBar: MatSnackBar, private changeRef: ChangeDetectorRef, private observer: BreakpointObserver, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private zone: NgZone) { }
	ngOnChanges(changes: SimpleChanges): void {
		if (changes['username']) {
		}
	}

	get f() { return this.passwordForm.controls; }

	passwordMatchValidator(formGroup: FormGroup) {
		const password = formGroup.get('password');
		const confirmPassword = formGroup.get('confirmPassword');
		return password!.value === confirmPassword!.value ? null : { passwordNotMatch: true };
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
					noop;
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.passwordForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			password: this.f.password.value
		};
		if (this.username) {
			data["email"] = this.username;
		}
		this.showLoader = true;
		this.apiService.resetPassword(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
				this.toastr.success("Password changed successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	clearForm() {
		this.passwordForm.reset();
		this.formSubmitted = false;
		this.cleared.emit();
		$("#" + this.modalId).modal("hide");
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	openResetPasswordModal() {
		$("#" + this.modalId).modal("show");
	}
}
